import { mount } from './dom-lifecycle';

/**
 * Licznik odliczający w dół.
 *
 * Serwer podaje POZOSTAŁE sekundy (`data-countdown-seconds`), a nie termin — zegar
 * przeglądarki bywa przestawiony, a różnica jest na to odporna. Tykanie liczymy od
 * `Date.now()` z chwili montażu, więc uśpiona karta po powrocie nadgania zamiast gubić
 * sekundy.
 *
 * Pola licznika to `[data-countdown-unit=hours|minutes|seconds]`; godzin nie zwijamy
 * w dni (72 GODZIN to celowo 72, nie 3 dni). Element z `data-countdown-reload` po dojściu
 * do zera odświeża stronę, żeby stan wygaśnięcia przyszedł z serwera — ale tylko jeśli
 * licznik jest jeszcze widoczny: po wysłaniu formularza strona pokazuje podziękowanie
 * i nie ma czego odświeżać.
 */
mount('[data-countdown-seconds]', function () {
    const root = this;
    const total = Number(root.dataset.countdownSeconds);

    if (!Number.isFinite(total)) {
        return;
    }

    const startedAt = Date.now();
    const units = {
        hours: root.querySelector('[data-countdown-unit=hours]'),
        minutes: root.querySelector('[data-countdown-unit=minutes]'),
        seconds: root.querySelector('[data-countdown-unit=seconds]'),
    };

    render(secondsLeft());
    const timer = window.setInterval(tick, 1000);

    function tick() {
        if (!root.isConnected) {
            window.clearInterval(timer);
            return;
        }

        const left = secondsLeft();
        render(left);

        if (left <= 0) {
            window.clearInterval(timer);
            expire();
        }
    }

    function secondsLeft() {
        return Math.max(total - Math.round((Date.now() - startedAt) / 1000), 0);
    }

    function render(left) {
        setUnit(units.hours, Math.floor(left / 3600));
        setUnit(units.minutes, Math.floor(left / 60) % 60);
        setUnit(units.seconds, left % 60);
    }

    function setUnit(el, value) {
        if (el) {
            el.textContent = String(value).padStart(2, '0');
        }
    }

    function expire() {
        const visible = root.offsetParent !== null;
        if (root.dataset.countdownReload !== undefined && visible) {
            location.reload();
        }
    }
});
